import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects'
import queryString from 'query-string'
import { replace } from 'connected-react-router'
import * as J from 'domain/superManager/jobs'
import { jobStatusSelector } from 'domain/constants'
import * as R from 'domain/router'
import * as M from 'domain/superManager/managers'
import { managersSelector } from 'domain/superManager/selectors'

export function* jobsList({ query, pathname }: { query: any; pathname: string }) {
  yield all([fork(getJobsList, { query, pathname }), fork(getManagers)])
}

function* getJobsList({ query, pathname }: { query: J.ParamsI; pathname: string }) {
  const jobStatuses = yield select(jobStatusSelector)
  const route = yield select(R.routing)
  const props = {
    payload: {
      ...query,
      status: query.status || jobStatuses.get('signed'),
      page: query.page || 1
    },
    type: J.superManagerJobsList.request
  }

  // load list from the first page and change params in url after reload
  const prevLocation = Object.keys(route.prevLocation || {}).length
  if (!prevLocation || (prevLocation && route.action === 'POP' && props.payload.page !== 1)) {
    const stringifyParams = queryString.stringify(
      { ...props.payload, page: 1 },
      { arrayFormat: 'bracket' }
    )
    yield put(replace(`${pathname}?${stringifyParams}`))
    return
  }
  yield call(J.ensureGetJobs, props)
  yield takeLatest(J.superManagerJobsList.type, J.ensureGetJobs)
}

function* getManagers() {
  const managers = yield select(managersSelector)
  if (managers.isEmpty()) yield call(M.ensureGetManagers)
}
